import useAppContext from './app-context';

const useCurrencyStore = () => useAppContext().currencyStore;

export default useCurrencyStore;